import LoadingUnstyled from './Loading';
import LoadingTheme from './LoadingTheme';

import { applyTheme } from '@cloudflare/style-container';

var Loading = applyTheme(LoadingUnstyled, LoadingTheme);

export { Loading, LoadingUnstyled, LoadingTheme };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-loading/es/index.js
// module id = 1092
// module chunks = 1